var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccounts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.165 7.54245V5.26245C21.165 4.16245 20.265 3.26245 19.165 3.26245H5.16504C4.05504 3.26245 3.16504 4.16245 3.16504 5.26245V19.2625C3.16504 20.3625 4.05504 21.2625 5.16504 21.2625H19.165C20.265 21.2625 21.165 20.3625 21.165 19.2625V16.9825C21.755 16.6325 22.165 16.0025 22.165 15.2625V9.26245C22.165 8.52245 21.755 7.89245 21.165 7.54245ZM20.165 9.26245V15.2625H13.165V9.26245H20.165ZM5.16504 19.2625V5.26245H19.165V7.26245H13.165C12.065 7.26245 11.165 8.16245 11.165 9.26245V15.2625C11.165 16.3625 12.065 17.2625 13.165 17.2625H19.165V19.2625H5.16504Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.165 13.7625C16.9935 13.7625 17.665 13.0909 17.665 12.2625C17.665 11.434 16.9935 10.7625 16.165 10.7625C15.3366 10.7625 14.665 11.434 14.665 12.2625C14.665 13.0909 15.3366 13.7625 16.165 13.7625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounts);
export default __webpack_public_path__ + "static/media/accounts.6b25bde0730e9bb52975fa305b011790.svg";
export { ForwardRef as ReactComponent };